export const TRAINING_PARAM = 'training';
export const PARENT_FRONTEND_PARAM = 'parent_frontend';
export const PARENT_FRONTEND_WORKSHOP = 'workshop';
export const PARENT_FRONTEND_CUSTOMER = 'customer';

export interface ConfigState {
    backend: {
        BACKEND_URI: string | undefined;
        WORKSHOP_BACKEND_URI: string | undefined;
        AUTHENTICATION_SERVICE: string | undefined;
        MENU_SERVICE: string | undefined;
    };
    homeRoute: string | undefined;
    id: string | undefined;
    login: {
        authority: string | undefined;
        clientId: string | undefined;
        oauthScope: string[];
        mockAuthorization: boolean;
        mockLocale: string | undefined;
        preventRedirect: boolean;
        redirectUri: string | undefined;
        silentRedirectUri: string | undefined;
    };
    logoutUri: string | undefined;
    sentryToken: string | undefined;
    sentryModuleName: string;
}

const getBoolEnvValue = (envValue: string): boolean => {
    return typeof process.env[envValue] !== 'undefined' && process.env[envValue] === 'true';
};

const getValueFromUrlParamOrLocalStorage = (paramName: string): string | undefined => {
    const currentUrl = new URL(window.location.href);
    const paramValue = currentUrl.searchParams.get(paramName);
    if (paramValue === null) {
        // if null we need to check the local storage
        const localStorageValue = window.localStorage.getItem(paramName);
        if (localStorageValue === null) {
            return undefined;
        }
        return localStorageValue;
    }
    return paramValue;
};

// This MicroFrontend can be integrated either on:
// - Customer Frontend (Rio Portal)
// - Workshop Frontend (Man Service Portal)
export const isWorkshopParentFrontend = (): boolean => {
    const paramValue = getValueFromUrlParamOrLocalStorage(PARENT_FRONTEND_PARAM);
    if (paramValue === undefined) {
        // by default start workshop-frontend
        return true;
    }
    return paramValue === PARENT_FRONTEND_WORKSHOP;
};

export const isTraining = (): boolean => {
    const paramValue = getValueFromUrlParamOrLocalStorage(TRAINING_PARAM);
    if (paramValue === undefined) {
        // by default set training to false
        return false;
    }
    return paramValue === 'true';
};

export const config: ConfigState = {
    backend: {
        BACKEND_URI: process.env.REACT_APP_BACKEND_URI,
        WORKSHOP_BACKEND_URI: process.env.REACT_APP_WORKSHOP_BACKEND_URI,
        AUTHENTICATION_SERVICE: isWorkshopParentFrontend()
            ? process.env.REACT_APP_MAN_AUTHENTICATION_SERVICE
            : process.env.REACT_APP_RIO_AUTHENTICATION_SERVICE,
        MENU_SERVICE: process.env.REACT_APP_RIO_MENU_SERVICE,
    },
    homeRoute: process.env.REACT_APP_RIO_HOME_ROUTE,
    id: process.env.REACT_APP_ID,
    login: {
        authority: isWorkshopParentFrontend()
            ? process.env.REACT_APP_MAN_LOGIN_AUTHORITY
            : process.env.REACT_APP_RIO_LOGIN_AUTHORITY,
        // TODO: Request and supply your App's `client_id` as
        //       well as the needed OAuth scopes here
        clientId: isWorkshopParentFrontend()
            ? process.env.REACT_APP_MAN_CLIENT_ID
            : process.env.REACT_APP_RIO_CLIENT_ID,
        oauthScope: isWorkshopParentFrontend()
            ? // note: offline_access is needed to activate refresh tokens by oidc-client
              ['email', 'openid', 'profile', 'offline_access', `${process.env.REACT_APP_MAN_CLIENT_ID}`]
            : ['email', 'openid', 'phone', 'profile', 'workshop-assignment.read', 'workshop-assignment.write'],
        mockAuthorization: getBoolEnvValue('REACT_APP_LOGIN_MOCK_AUTHORIZATION'),
        mockLocale: process.env.REACT_APP_LOGIN_MOCK_LOCALE,
        preventRedirect: getBoolEnvValue('REACT_APP_LOGIN_PREVENT_REDIRECT'),
        redirectUri: process.env.REACT_APP_LOGIN_REDIRECT_URI,
        silentRedirectUri: process.env.REACT_APP_LOGIN_SILENT_REDIRECT_URI,
    },
    logoutUri: isWorkshopParentFrontend() ? process.env.REACT_APP_MAN_LOGOUT_URI : process.env.REACT_APP_RIO_LOGOUT_URI,
    sentryToken: process.env.REACT_APP_SENTRY_DSN,
    sentryModuleName: 'starterTemplate',
};
